export default __webpack_public_path__ + "static/overlay_2-c825299798d177fb53c7efaddabe3013.jpg";